import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';

@Injectable({ providedIn: 'root' })
export class CanActivateWriteRoute {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  canActivate() {
    const isWrite = this.userService.isWrite();
    if (isWrite) {
      return isWrite;
    } else {
      this.router.navigate(['/settings']);
    }
  }
}
